import { render, staticRenderFns } from "./NotificationInfo.vue?vue&type=template&id=35217eb3"
import script from "./NotificationInfo.vue?vue&type=script&lang=js"
export * from "./NotificationInfo.vue?vue&type=script&lang=js"
import style0 from "./NotificationInfo.vue?vue&type=style&index=0&id=35217eb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports